export function Section({ title, children, action }) {
  return (
    <section className="mx-4 mt-4 bg-white border border-zinc-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
